import styled from 'styled-components';

import { TOGGLE_ICON_SIZE } from '@wecasa/common/src/components/accordion/constants';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Skeleton from '@wecasa/web-ui/src/components/skeleton/skeleton';

const t = translate('basket.cleaning.services');

const StyledSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-right: ${15 + TOGGLE_ICON_SIZE}px;
`;
const StyledFirstSessionSubtitle = styled(Text.SM)`
  text-align: right;
`;

type FirstSessionSubtitleProps = {
  formattedFirstSessionPrice: string;
  isLoading: boolean;
};

const FirstSessionSubtitle = ({ formattedFirstSessionPrice, isLoading }: FirstSessionSubtitleProps) => (
  <StyledSubtitle>
    {isLoading ? (
      <Skeleton linesWidth={['150px']} />
    ) : (
      <StyledFirstSessionSubtitle>
        {t('.first_session_subtitle', { price: formattedFirstSessionPrice })}
      </StyledFirstSessionSubtitle>
    )}
  </StyledSubtitle>
);

type ITCSubtitleProps = {
  formattedTotalPriceAfterTax: string;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isLoading: boolean;
};

export const ITCSubtitle = ({
  formattedTotalPriceAfterTax,
  isITCSelectedOrSuccessfullyPaired,
  isLoading,
}: ITCSubtitleProps) => {
  if (isLoading)
    return (
      <StyledSubtitle>
        <Skeleton linesWidth={isITCSelectedOrSuccessfullyPaired ? ['70px'] : ['70px', '110px']} />
      </StyledSubtitle>
    );

  return (
    <StyledSubtitle>
      {isITCSelectedOrSuccessfullyPaired ? (
        <Text.MDBold>{formattedTotalPriceAfterTax}</Text.MDBold>
      ) : (
        <>
          <Text>{`${t('base.or')} ${formattedTotalPriceAfterTax}`}</Text>
          <Text.SM>{`\xa0${t('.accordion_subtitle_after_tax')}`}</Text.SM>
        </>
      )}
    </StyledSubtitle>
  );
};

type AccordionSubtitlePriceProps = {
  formattedTotalPriceAfterTax: string;
  formattedFirstSessionPrice?: string;
  isITCSelectedOrSuccessfullyPaired: boolean;
  isLoading: boolean;
  shouldShowTaxCreditLines: boolean;
};

const AccordionSubtitlePrice = ({
  formattedTotalPriceAfterTax,
  formattedFirstSessionPrice,
  isITCSelectedOrSuccessfullyPaired,
  isLoading,
  shouldShowTaxCreditLines,
}: AccordionSubtitlePriceProps) => {
  if (formattedFirstSessionPrice)
    return <FirstSessionSubtitle formattedFirstSessionPrice={formattedFirstSessionPrice} isLoading={isLoading} />;

  if (shouldShowTaxCreditLines)
    return (
      <ITCSubtitle
        formattedTotalPriceAfterTax={formattedTotalPriceAfterTax}
        isITCSelectedOrSuccessfullyPaired={isITCSelectedOrSuccessfullyPaired}
        isLoading={isLoading}
      />
    );

  return null;
};

export default AccordionSubtitlePrice;
